import requset from "utils/request";
import baseURL from '@/api/env.js'
/* 重置 */
export function modifybankinfo(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/modify/bankinfo`,
        method: "POST",
        params
    });
}
/* 获取银行 */
export function payloggetBank(params) {
    return requset({
        url: `${baseURL.AHEAD}/consume/core/paylog/getBank`,
        method: "GET",
        params
    });
}
/* 获取省市 */
export function paylogprovince(params) {
    return requset({
        url: `${baseURL.AHEAD}/consume/core/paylog/province`,
        method: "GET",
        params
    });
}
/* 作品列表 */
export function authorBookListApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/list`,
        method: "GET",
        params
    });
}
/* 作品提交审核 */
// /book/core/pc/apply
export function BookApplyApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/apply`,
        method: "POST",
        params
    });
}

/* 创建作品 ---> 分类*/
export function sortListApi() {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/sort/list`,
        method: "GET"
    });
}

/* 创建作品 ---> 责编*/
export function editorListApi() {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/editor/list`,
        method: "GET"
    });
}

/* 创建作品 ---> 标签 */
export function tagsListApi() {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/tag/list`,
        method: "GET"
    });
}


/* 添加作品保存 */
export function addBookApi(data) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/add`,
        method: "POST",
        data
    });
}
/* 删除作品保存 */
export function delBookApi(bookid) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/del/${bookid}`,
        method: "GET",
        // params
    });
}

/* 根据作品id获取可编辑信息 */
export function getbookinfoApi(bookid) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/edit/${bookid}`,
        method: "GET"
    });
}
/* 修改作品信息保存 */
export function editbookApi(data, bookid) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/edit`,
        method: "POST",
        data
    });
}
/* 收集银行信息 */
export function modifybank(data) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/modify/bank`,
        method: "POST",
        data
    });
}
/********************章节************************/
/* 根据作品id获取作品信息 */
export function bookInfoApi(bookid) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/${bookid}`,
        method: "GET"
    });
}

// 获取章节列表
export function getchapterlistApi(bookid) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/chapter/list/${bookid}`,
        method: "GET",
    });
}
/* =====发布章节 */
// 发布新章节
export function addChapterApi(data) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/chapter/add`,
        method: "POST",
        data
    });
}
// 修改章节
export function editChapterApi(data) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/chapter/edit`,
        method: "POST",
        data
    });
}
// 删除章节
export function delChapterApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/chapter/del`,
        method: "POST",
        params
    });
}
// 获取章节内容
export function getChapterInfoApi(chapterId) {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/chapter/${chapterId}`,
        method: "GET"
    });
}

// 获取敏感词
export function getReplaceContent() {
    return requset({
        url: `${baseURL.AHEAD}/book/core/pc/get/replace/content`,
        method: "GET"
    });
}
/* ================================作品签约 */
// 获取作家基本信息
export function writerInfoApi() {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/info`,
        method: "GET"
    });
}
// 修改基本信息
export function writerEditApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/modify`,
        method: "POST",
        params
    });
}

//
/* 发送邮箱验证码 */
export function emailCheckApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/sign/inspect/sendCode`,
        method: "POST",
        params
    });
}


/* ============签约页面======== */
/* 获取状态 */
export function bookInvitedApi(id) {
    return requset({
        url: `${baseURL.AHEAD}/writer/sign/inspect/book/invited/${id}`,
        method: "GET"
    });
}
/* 获取图片 */
export function writerImgApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/idcard/img`,
        method: "GET",
        params
    });
}
/* 签约进展 */
export function getProgressApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/sign/inspect/progress`,
        method: "GET",
        params
    });
}
/* 提交申请签约 */
export function inspectSignApi(data) {
    return requset({
        url: `${baseURL.AHEAD}/writer/sign/inspect/sign`,
        method: "POST",
        data
    });
}

/* ============收益页面======== */
/* 收益列表 */
export function getPaylogListApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/paylog/list`,
        method: "GET",
        params
    });
}
/* 可提现记录列表 */
export function getPaylogUndrawnApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/paylog/undrawn`,
        method: "GET",
        params
    });
}
/* 作家提现记录列表 */
export function getWriterListApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/writercash/list`,
        method: "GET",
        params
    });
}

/* 作家申请提现 */
export function writerCashApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/writer/writer/writercash/add`,
        method: "POST",
        params
    });
}
